/**
 * @generated SignedSource<<2cc7003d014f924e75ceb3077ebad92b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type yourSayAuthorAuthor$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"authorAvatarAuthor">;
  readonly " $fragmentType": "yourSayAuthorAuthor";
};
export type yourSayAuthorAuthor$key = {
  readonly " $data"?: yourSayAuthorAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"yourSayAuthorAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "yourSayAuthorAuthor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorAvatarAuthor"
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "ebaef0ed3526ef945bdb90b5f0049455";

export default node;
